import React, { Component, Fragment } from "react";
import AUX from "../../../hoc/Aux_";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import axios from "../../Shared/auth-header";
import $ from "jquery";
import { Link } from "react-router-dom";
import ConfirmDeleteModal from "../../Shared/Modals";
import { toast } from "react-toastify";
import TeamSearch from "./TeamSearch";
import EditTeam from "./EditTeam";
import { connect } from "react-redux";
import PermissionAction from "../../../store/permission/action";
import PermissionHeader from "../General/PermissionHeader";
import Services from "../PermissionService";
import _ from "lodash";
import DefaultPermissionModal from "../DefaultPermission/DefaultPermissionModal";
import AuthService from "../../Auth/AuthService";
import TableCustomTotal from "../../Shared/TableCustomTotal";
class Teams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      perms: "",
      page: 1,
      sizePerPage: localStorage.getItem("teamsPageSize")
        ? parseInt(localStorage.getItem("teamsPageSize"))
        : 10,
      keyword: this.props.location.keyword || "",
      data: [],
      totalCount: "",
      delId: 0,
      advSearch: {
        Name: "",
        MemberName: "",
        PositionName: "",
        City: "",
        State: "",
        County: "",
      },

      currentTab: 1,
      scopes: [],
      teamTypes: [],
      expandedAccordions: [],
    };

    this.confirm = () => {
      this.confirmed = () => {
        if (this.state.delId == 0) {
          return false;
        }

        axios
          .delete("/api/Team/" + this.state.delId)
          .then(({ data }) => {
            if (data.status && data.status == "Success") {
              toast.success("Team Deleted Successfuly.");
              this.setState({ delId: 0 });
              $(".cancelModal").trigger("click");
              this.getTeams();
            } else {
              toast.error(data.message);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      };
      return this;
    };
    this.columns = [
      {
        text: "Team Name",
        dataField: "teamName",
        headerClasses: "team-list-header px-sm-3 px-2 py-2",
        classes: "px-3 py-2 c-pointer",
        sort: true,
        headerAttrs: { style: { width: "70%" } }, // or whatever width you want
      },
      {
        text: "Owner",
        //dataField: "count",
        dataField: "ownerName",
        headerClasses: "team-list-header px-sm-3 px-2 py-2",
        classes: "px-3 py-2 c-pointer",
        sort: true,
        headerAttrs: { style: { width: "30%" } }, // or whatever width you want
      },
    ];
    this.rowEvents = {
      onClick: (e, row, rowIndex) => {
        this.teamDetailPage(e, row.id);
      },
    };

    this.teamDetailPage = (e, id) => {
      if (e.target.className.indexOf("del") < 0) {
        this.props.history.push({
          pathname: "/permissions/teams/teamDetail/" + id,
          type: "add",
          uid: id,
          keyword: this.state.searchTerm,
        });
      }
    };
    const columns = [
      {
        dataField: "region",
        text: "TEAM NAME",
        headerAttrs: {
          width: "85%",
        },
        headerClasses: "bg-dark text-white px-sm-3 px-2 py-2",
        sort: true,
        classes: "px-3 py-2 border-right-0 bg-secondary text-white",
      },
      {
        text: "OWNER",
        headerClasses: "bg-dark text-white px-sm-3 px-2 py-2 text-center",
        classes: "px-3 py-2 border-left-0 bg-secondary text-white",
        headerAttrs: {
          width: "15%",
        },
        formatter: (cellContent, row, isExpand) => {
          return (
            <div className="text-right">
              <i className={"fas fa-chevron-down fa-lg "} />
            </div>
          );
        },
      },
    ];
    const columnsFacility = [
      {
        text: "TEAM NAME",
        headerAttrs: {
          width: "85%",
        },
        headerClasses:
          "facility-Region-MainHeader bg-dark text-white px-sm-3 px-2 py-2",
        classes: "px-3 py-2 border-right-0 bg-secondary text-white",
        formatter: (cellContent, row, isExpand) => (
          <div className="region-header">
            {row.region + " - " + row.facility}
          </div>
        ),
      },
      {
        text: "OWNER",
        headerClasses:
          "facility-Region-MainHeader bg-dark text-white px-sm-3 px-2 py-2 text-center",
        classes: "px-3 py-2 border-left-0 bg-secondary text-white",
        headerAttrs: {
          width: "15%",
        },
        formatter: (cellContent, row, isExpand) => {
          return (
            <div className="text-right">
              <i className={"fas fa-chevron-down fa-lg "} />
            </div>
          );
        },
      },
    ];

    const regionColumns = [
      {
        dataField: "region",
        text: "TEAM NAME",
        headerAttrs: {
          width: "85%",
        },
        headerClasses:
          "facility-Region-MainHeader bg-dark text-white px-sm-3 px-2 py-2 text-left",
        sort: true,
        classes: "px-3 py-2 border-right-0 bg-secondary text-white",
        // or use a formatter for more control:
        formatter: (cell, row) => <div className="region-header">{cell}</div>,
      },
      {
        text: "OWNER",
        headerClasses:
          "facility-Region-MainHeader bg-dark text-white px-sm-3 px-2 py-2 text-center",
        classes: "px-3 py-2 border-left-0 bg-secondary text-white",
        headerAttrs: {
          width: "15%",
        },
        formatter: (cellContent, row, isExpand) => {
          return (
            <div className="text-right">
              <i className={"fas fa-chevron-down fa-lg "} />
            </div>
          );
        },
      },
    ];
    const expandRow = {
      renderer: (row) => (
        <React.Fragment>
          {row.teams.map((item, index) => (
            <div
              key={"expend-" + row.id + "-" + index}
              className="d-flex px-0 w-100 border-top c-pointer border-bottom"
              onClick={(e) => {
                this.teamDetailPage(e, item.id);
              }}
            >
              <div className="px-3 py-2 border-right" style={{ width: "85%" }}>
                {item.teamName}
              </div>
              <div className="px-3 py-2 border-left" style={{ width: "15%" }}>
                {item.ownerName}
              </div>
            </div>
          ))}
        </React.Fragment>
      ),
      onExpand: (row, isExpand, rowIndex, e) => {
        console.log($(e.target).find(".fa-chevron-down"));
        if (isExpand) {
          $(e.target)
            .parent()
            .find(".fa-chevron-down")
            .addClass("fa-chevron-up");

          $(e.target)
            .parent()
            .find(".fa-chevron-down")
            .removeClass("fa-chevron-down");
        } else {
          $(e.target)
            .parent()
            .find(".fa-chevron-up")
            .addClass("fa-chevron-down");

          $(e.target)
            .parent()
            .find(".fa-chevron-up")
            .removeClass("fa-chevron-up");
        }
      },
    };

    // const tableExpandRow = {
    //   renderer: (region) => {
    //     const groupedTeams = this.groupTeamsByType(region.teams);
    //     const safeGroupedTeams = groupedTeams || {};
    //     const typesWithTeams = Object.keys(safeGroupedTeams).filter(
    //       type => Array.isArray(safeGroupedTeams[type]) && safeGroupedTeams[type].length > 0
    //     );
    //     return (
    //       <div className="p-2">
    //         {typesWithTeams.length > 1 ? (
    //           <div className="team-accordions">
    //             {typesWithTeams.map(type =>
    //               this.TeamTypeTableListing({
    //                 key: type,
    //                 type: type,
    //                 teams: groupedTeams[type],
    //                 columns: this.columns,
    //                 rowEvents: this.rowEvents
    //               })
    //             )}
    //           </div>
    //         ) : (
    //           <BootstrapTable
    //             keyField="id"
    //             data={region.teams || []}
    //             columns={this.columns}
    //             rowEvents={this.rowEvents}
    //             pagination={
    //               (Array.isArray(region.teams) && region.teams.length > 10)
    //                 ? paginationFactory({
    //                     paginationTotalRenderer: TableCustomTotal,
    //                     page: 1,
    //                     sizePerPage: 10,
    //                     onPageChange: (page, pageSize) => {
    //                       localStorage.setItem("teamsPageNumber", page);
    //                       localStorage.setItem("teamsPageSize", pageSize);
    //                     },
    //                   })
    //                 : undefined
    //             }
    //           />
    //         )}
    //       </div>
    //     );
    //   },
    //   onExpand: (row, isExpand, rowIndex, e) => {
    //     console.log($(e.target).find(".fa-chevron-down"));
    //     if (isExpand) {
    //       $(e.target)
    //         .parent()
    //         .find(".fa-chevron-down")
    //         .addClass("fa-chevron-up");

    //       $(e.target)
    //         .parent()
    //         .find(".fa-chevron-down")
    //         .removeClass("fa-chevron-down");
    //     } else {
    //       $(e.target)
    //         .parent()
    //         .find(".fa-chevron-up")
    //         .addClass("fa-chevron-down");

    //       $(e.target)
    //         .parent()
    //         .find(".fa-chevron-up")
    //         .removeClass("fa-chevron-up");
    //     }
    //   },
    // };
    const accordionExpandRow = {
      renderer: (facility) => {
        const groupedTeams = this.groupTeamsByType(facility.teams);
        const safeGroupedTeams = groupedTeams || {};
        const typesWithTeams = Object.keys(safeGroupedTeams).filter(
          (type) =>
            Array.isArray(safeGroupedTeams[type]) &&
            safeGroupedTeams[type].length > 0
        );
        return (
          <div className="p-2">
            {typesWithTeams.length > 1 ? (
              <div className="team-accordions">
                {typesWithTeams.map((type) =>
                  this.NestedAccordion({
                    key: type,
                    type: type,
                    teams: groupedTeams[type],
                    columns: this.columns,
                    rowEvents: this.rowEvents,
                  })
                )}
              </div>
            ) : (
              <React.Fragment>
                {facility.teams.map((item, index) => (
                  <div
                    key={"expend-" + facility.id + "-" + index}
                    className="d-flex px-0 w-100 border-top c-pointer border-bottom"
                    onClick={(e) => {
                      this.teamDetailPage(e, item.id);
                    }}
                  >
                    <div
                      className="px-3 py-2 border-right"
                      style={{ width: "85%" }}
                    >
                      {item.teamName}
                    </div>
                    <div
                      className="px-3 py-2 border-left"
                      style={{ width: "15%" }}
                    >
                      {item.ownerName}
                    </div>
                  </div>
                ))}
              </React.Fragment>
            )}
          </div>
        );
      },
      onExpand: (row, isExpand, rowIndex, e) => {
        console.log($(e.target).find(".fa-chevron-down"));
        if (isExpand) {
          $(e.target)
            .parent()
            .find(".fa-chevron-down")
            .addClass("fa-chevron-up");

          $(e.target)
            .parent()
            .find(".fa-chevron-down")
            .removeClass("fa-chevron-down");
        } else {
          $(e.target)
            .parent()
            .find(".fa-chevron-up")
            .addClass("fa-chevron-down");

          $(e.target)
            .parent()
            .find(".fa-chevron-up")
            .removeClass("fa-chevron-up");
        }
      },
    };

    this.getTeams();
    this.RemotePagination = (rowEvents) => {
      //console.log('Remote Pagination');
      const nationalTeams = this.nationalFilters();
      //console.log('National teams:', nationalTeams);
      const groupedTeams = this.groupTeamsByType(nationalTeams);
      //console.log('Grouped teams:', groupedTeams);
      const typesWithTeams = Object.values(groupedTeams).filter(
        (arr) => arr.length > 0
      ).length;
      const moreThanOneTypeHasRecords = typesWithTeams > 1;
      debugger;
      return (
        <div>
          {this.props.permissionState.permissionActiveTab === 1 && (
            <React.Fragment>
              {Object.entries(groupedTeams).length > 0 &&
              moreThanOneTypeHasRecords ? (
                <div className="team-accordions">
                  {Object.entries(groupedTeams).map(([type, teams]) => {
                    //console.log('Rendering accordion for type:', type, 'with teams:', teams);
                    return this.TeamTypeTableListing({
                      key: type,
                      type: type,
                      teams: teams,
                      columns: this.columns,
                      rowEvents: rowEvents,
                    });
                  })}
                </div>
              ) : (
                <BootstrapTable
                  keyField="id"
                  data={nationalTeams}
                  columns={this.columns}
                  pagination={paginationFactory({
                    paginationTotalRenderer: TableCustomTotal,
                    page: localStorage.getItem("teamsPageNumber")
                      ? parseInt(localStorage.getItem("teamsPageNumber"))
                      : this.state.page,
                    sizePerPage: localStorage.getItem("teamsPageSize")
                      ? parseInt(localStorage.getItem("teamsPageSize"))
                      : this.state.sizePerPage,
                    onPageChange: (page, pageSize) => {
                      localStorage.setItem("teamsPageNumber", page);
                      localStorage.setItem("teamsPageSize", pageSize);
                    },
                  })}
                  rowEvents={rowEvents}
                />
              )}
            </React.Fragment>
          )}
          {this.props.permissionState.permissionActiveTab === 2 &&
            (this.state.data.regionTeams &&
            !_.isEmpty(this.state.data.regionTeams) ? (
              <BootstrapTable
                keyField="regionID"
                data={this.regionfacilityFilters(this.state.data.regionTeams)}
                columns={regionColumns}
                expandRow={accordionExpandRow}
                bordered={false}
                wrapperClasses="region-team-table"
              />
            ) : (
              <div class="container h-100">
                <div class="row spinnerFacilityCategory">
                  <h5>No Teams Found!</h5>
                </div>
              </div>
            ))}
          {this.props.permissionState.permissionActiveTab === 3 &&
            (this.state.data.facilityTeams &&
            !_.isEmpty(this.state.data.facilityTeams) ? (
              <BootstrapTable
                keyField="facilityID"
                data={this.regionfacilityFilters(this.state.data.facilityTeams)}
                columns={columnsFacility}
                expandRow={accordionExpandRow}
                wrapperClasses="facility-team-table"
              />
            ) : (
              <div class="container h-100">
                <div class="row spinnerFacilityCategory">
                  <h5>No Teams Found!</h5>
                </div>
              </div>
            ))}
        </div>
      );
    };
    this.setReloader = this.setReloader.bind(this);
    this.handleDefaultPermissionModal = this.handleDefaultPermissionModal.bind(
      this
    );
    this.closeDefaultPermissionModal = this.closeDefaultPermissionModal.bind(
      this
    );
  }
  nationalFilters() {
    return this.state.data.nationalTeams.filter(
      (itemQ) =>
        _.toLower(itemQ.teamName).includes(
          _.toLower(this.state.searchTerm || "")
        ) ||
        _.toLower(itemQ.ownerName).includes(
          _.toLower(this.state.searchTerm || "")
        )
    );
  }
  regionfacilityFilters(data) {
    let as = data.filter(
      (itemR) =>
        _.toLower(itemR.region).includes(
          _.toLower(this.state.searchTerm || "")
        ) ||
        _.toLower(itemR.facility).includes(
          _.toLower(this.state.searchTerm || "")
        ) ||
        itemR.teams.find(
          (itemT) =>
            _.toLower(itemT.teamName).includes(
              _.toLower(this.state.searchTerm || "")
            ) ||
            _.toLower(itemT.ownerName).includes(
              _.toLower(this.state.searchTerm || "")
            )
        )
    );
    return _.cloneDeep(as).map((item) => {
      item.teams = item.teams.filter(
        (itemT) =>
          _.toLower(itemT.teamName).includes(
            _.toLower(this.state.searchTerm || "")
          ) ||
          _.toLower(itemT.ownerName).includes(
            _.toLower(this.state.searchTerm || "")
          )
      );
      return item;
    });
  }

  async getTeams() {
    $(".loading").show();
    let data = await Services.GetTeams();
    if (!_.isEmpty(data)) {
      if (data.statusCode == 200) {
        await this.setState({ data: data.result });
      } else {
        toast.error("Data loading error. Please, refresh your page!");
      }
    }

    $(".loading").hide();
  }

  async componentDidMount() {
    this.props.history.push("/permissions/teams");
    try {
      const response = await Services.TeamTypes();
      if (response && response.result) {
        const teamTypes = response.result.map((type) => ({
          id: type.id,
          name: type.teamtype || type.name,
        }));
        this.setState({ teamTypes });
        if (
          !this.state.teamTypes.some((type) => type.name === "Default Teams")
        ) {
          this.setState((prev) => ({
            teamTypes: [...prev.teamTypes, { id: null, name: "Default Teams" }],
          }));
        }
      }
    } catch (error) {
      console.error("Failed to fetch team types", error);
    }
  }
  setReloader() {
    this.setState({ reloadEverything: true });
  }
  componentDidUpdate() {
    if (this.state.reloadEverything) {
      this.state.reloadEverything = false;

      this.getTeams();
      this.setState({ reloadEverything: this.state.reloadEverything });
    }
  }
  componentWillUnmount() {}
  closeDefaultPermissionModal() {
    this.props.closeDefaultPermissionModal();
  }
  handleDefaultPermissionModal = () => {
    this.props.openDefaultPermissionModal();
  };
  handleEditTeam = async () => {
    $(".loading").show();
    let data = await Services.TeamScopes(null);
    !_.isEmpty(data) && (await this.setState({ scopes: data.result }));
    window.$("#CreateTeamModal").modal({
      backdrop: "static",
      keyboard: true,
      show: true,
    });
    $(".loading").hide();
  };
  groupTeamsByType(teams) {
    //console.log('Input teams:', teams); // Debug log
    const groupedTeams = {};

    // Initialize groups for each team type
    this.state.teamTypes.forEach((type) => {
      groupedTeams[type.name] = [];
    });

    // Group teams by their type
    teams.forEach((team) => {
      //console.log('Processing team:', team); // Debug log
      //console.log('teamTypeId:', team.teamTypeId); // Debug log

      // Find the team type name based on teamTypeId
      const teamType = this.state.teamTypes.find(
        (type) => type.id === team.teamTypeId
      );
      //console.log('Found team type:', teamType); // Debug log

      const typeName = teamType ? teamType.name : "Default Teams";
      //console.log('Using type name:', typeName); // Debug log

      if (groupedTeams[typeName]) {
        groupedTeams[typeName].push(team);
      }
    });

    //console.log('Grouped teams:', groupedTeams); // Debug log
    return groupedTeams;
  }
  toggleAccordion(type) {
    const { expandedAccordions } = this.state;
    const index = expandedAccordions.indexOf(type);

    if (index === -1) {
      expandedAccordions.push(type);
    } else {
      expandedAccordions.splice(index, 1);
    }

    this.setState({ expandedAccordions });
  }
  isAccordionExpanded(type) {
    return this.state.expandedAccordions.includes(type);
  }
  TeamTypeTableListing = ({ type, teams, columns, rowEvents }) => {
    if (!teams || teams.length === 0) return null;

    const isExpanded = this.isAccordionExpanded(type);
    const teamType = this.state.teamTypes.find((t) => t.name === type);

    return (
      <div className="card mb-2">
        <div className="card-header-team-list" id={`heading${type}`}>
          <h2 className="px-0 py-0 mx-1 my-1">
            <button
              className="btn btn-link btn-block text-left d-flex justify-content-between align-items-center"
              type="button"
              onClick={() => this.toggleAccordion(type)}
            >
              <span>
                {type} ({teams.length})
              </span>
              <i className={`fas fa-chevron-${isExpanded ? "up" : "down"}`}></i>
            </button>
          </h2>
        </div>

        <div
          className={`collapse ${isExpanded ? "show" : ""}`}
          aria-labelledby={`heading${type}`}
        >
          <div className="card-body p-0">
            <BootstrapTable
              keyField="id"
              data={teams || []}
              columns={columns}
              rowEvents={rowEvents}
              pagination={
                Array.isArray(teams) && teams.length > 10
                  ? paginationFactory({
                      paginationTotalRenderer: TableCustomTotal,
                      page: 1,
                      sizePerPage: 10,
                      onPageChange: (page, pageSize) => {
                        localStorage.setItem("teamsPageNumber", page);
                        localStorage.setItem("teamsPageSize", pageSize);
                      },
                    })
                  : undefined
              }
            />
          </div>
        </div>
      </div>
    );
  };
  NestedAccordion = ({ type, teams, columns, rowEvents }) => {
    if (!teams || teams.length === 0) return null;

    const isExpanded = this.isAccordionExpanded(type);
    const teamType = this.state.teamTypes.find((t) => t.name === type);

    return (
      <div className="card mb-2">
        <div className="card-header-team-list" id={`heading${type}`}>
          <h2 className="px-0 py-0 mx-1 my-1">
            <button
              className="btn btn-link btn-block text-left d-flex justify-content-between align-items-center"
              type="button"
              onClick={() => this.toggleAccordion(type)}
            >
              <span>
                {type} ({teams.length})
              </span>
              <i className={`fas fa-chevron-${isExpanded ? "up" : "down"}`}></i>
            </button>
          </h2>
        </div>

        <div
          className={`collapse ${isExpanded ? "show" : ""}`}
          aria-labelledby={`heading${type}`}
        >
          <div className="card-body p-0">
            <React.Fragment>
              {(teams || []).map((item, index) => (
                <div
                  key={"team-" + item.id + "-" + index}
                  className="d-flex px-0 w-100 border-top c-pointer border-bottom"
                  onClick={(e) => {
                    rowEvents &&
                      rowEvents.onClick &&
                      rowEvents.onClick(e, item, index);
                    // or: this.teamDetailPage(e, item.id);
                  }}
                >
                  <div
                    className="px-3 py-2 border-right"
                    style={{ width: "85%" }}
                  >
                    {item.teamName}
                  </div>
                  <div
                    className="px-3 py-2 border-left"
                    style={{ width: "15%" }}
                  >
                    {item.ownerName}
                  </div>
                </div>
              ))}
            </React.Fragment>
          </div>
        </div>
      </div>
    );
  };
  render() {
    // New Work
    const { data } = this.state;
    const showTotal = true;
    return (
      <AUX>
        <PermissionHeader
          beginEditTeam={this.handleEditTeam}
          handleDefaultPermissionModal={this.handleDefaultPermissionModal}
        />
        <div className="team-container container-fluid">
          <div className="page-title-box">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h4 className="text-uppercase page-title-search">Teams</h4>

                <form role="search" className="app-search mt-0">
                  <div className="form-group mb-0">
                    <input
                      type="text"
                      id="keyword"
                      className="form-control rounded border mb-1 w-100"
                      placeholder="Team Search.."
                      onChange={(event) => {
                        const searchTerm = event.target.value;
                        this.setState({ searchTerm }, () => {
                          if (searchTerm) {
                            // Find which accordions should be expanded
                            const filteredTeams = this.state.data.nationalTeams.filter(
                              (itemQ) =>
                                _.toLower(itemQ.teamName).includes(
                                  _.toLower(searchTerm)
                                ) ||
                                _.toLower(itemQ.ownerName).includes(
                                  _.toLower(searchTerm)
                                )
                            );
                            const matchingTypes = new Set();
                            filteredTeams.forEach((team) => {
                              const teamType = this.state.teamTypes.find(
                                (type) => type.id === team.teamTypeId
                              );
                              matchingTypes.add(
                                teamType ? teamType.name : "Team"
                              );
                            });
                            this.setState({
                              expandedAccordions: Array.from(matchingTypes),
                            });
                          } else {
                            this.setState({ expandedAccordions: [] });
                          }
                        });
                      }}
                    />
                    <button
                      type="button"
                      className="c-pointer text-secondary bg-transparent border-0"
                      onClick={(event) =>
                        this.setState({ searchTerm: $("#keyword").val() })
                      }
                    >
                      <i className="fa fa-search" />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {(data.nationalTeams || data.regionTeams || data.facilityTeams) &&
                this.RemotePagination(this.rowEvents)}
            </div>
          </div>
        </div>
        <ConfirmDeleteModal confirm={this.confirm} />
        <DefaultPermissionModal />
        {!_.isEmpty(this.state.scopes) && (
          <EditTeam scopes={this.state.scopes} setReloader={this.setReloader} />
        )}
      </AUX>
    );
  }
}

export default connect((state) => ({ permissionState: state.permission }), {
  ...PermissionAction,
})(Teams);
